import React from "react";
import styled from "styled-components";

const FooterContainer = styled.footer`
  align-items: start;
  align-content: flex-start;
  flex-wrap: wrap;
  border-top: 0.0625em solid var(--Color-Neutral-neutral-7, #282d32);
  display: flex;
  margin-top: 5.5em;
  width: 100%;
  padding-top: 1.5em;
  padding-bottom: 1.5em;
  justify-content: start;
  overflow: hidden;
  font-family: Manrope, -apple-system, Roboto, Helvetica, sans-serif;
  color: #717981;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 2.5em;
  }
`;

const FooterContent = styled.div`
  display: flex;
  min-width: 15em;
  width: 100%;
  align-items: start;
  gap: 2.5em 3.5em;
  justify-content: start;
  flex-wrap: wrap;
  flex: 1;
  flex-shrink: 1;
  flex-basis: 0%;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const LogoContainer = styled.div`
  flex-shrink: 0;
`;

const Logo = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 1.5em;
`;

const MainContent = styled.div`
  display: flex;
  min-width: 15em;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  flex: 1;
  flex-shrink: 1;
  flex-basis: 0%;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const EmailSection = styled.div`
  align-self: start;
  display: flex;
  align-items: start;
  gap: 0.5em;
  font-size: 1em;
  font-weight: 500;
  white-space: nowrap;
  letter-spacing: -0.02em;
  line-height: 1;
  justify-content: start;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const EmailLabel = styled.span`
  color: #717981;
`;

const EmailAddress = styled.span`
  color: #fff;
  text-align: right;
`;

const Separator = styled.span`
  color: #717981;
`;

const CompanyInfo = styled.div`
  display: flex;
  margin-top: 1.5em;
  width: 100%;
  align-items: end;
  gap: 2.5em 6.25em;
  font-size: 0.75em;
  font-weight: 400;
  justify-content: space-between;
  flex-wrap: wrap;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const CompanyDetails = styled.div`
  display: flex;
  min-width: 15em;
  align-items: center;
  gap: 1.5em;
  line-height: 1em;
  justify-content: start;
  flex-wrap: wrap;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const CompanyText = styled.p`
  color: #717981;
  opacity: 0.5;
  align-self: stretch;
  margin-top: auto;
  margin-bottom: auto;
  width: 28.375em;
  margin: 0;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const CopyrightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.875em;
  white-space: nowrap;
  line-height: 1;
  justify-content: start;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const CopyrightText = styled.span`
  color: #717981;
  opacity: 0.5;
  align-self: stretch;
  margin-top: auto;
  margin-bottom: auto;
`;

const CertificationLogo = styled.img`
  object-fit: contain;
  object-position: center;
  align-self: stretch;
  margin-top: auto;
  margin-bottom: auto;
  flex-shrink: 0;
  ${props => props.aspectRatio && `aspect-ratio: ${props.aspectRatio};`}
  ${props => props.width && `width: ${props.width};`}
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <LogoContainer>
          <Logo src="/images/logo.svg" alt="xplay logo" />
        </LogoContainer>
        <MainContent>
          <EmailSection>
            <EmailLabel>email:</EmailLabel>
            <EmailAddress>support@xplay.gg</EmailAddress>
            <Separator>|</Separator>
            <EmailAddress>marketing@xplay.gg</EmailAddress>
          </EmailSection>
          <CompanyInfo>
            <CompanyDetails>
              <CompanyText>
                CS Virtual Trade Ltd, reg. no. HE 389299Registered address
                and principal place of business: 705, Spyrou Araouzou &
                Koumantarias, Fayza House, 3036, Limassol, Cyprus
              </CompanyText>
              <CompanyText>
                G2G Marketplace Limited, reg.no. 3064044Registered address
                and the principal place of business: 8F, 30 Hollywood Road,
                Central, Hong Kong
              </CompanyText>
            </CompanyDetails>
            <CopyrightSection>
              <CopyrightText>2024</CopyrightText>
              <Separator>|</Separator>
              <CertificationLogo
                src="/images/visa.svg"
                alt="Certification logo"
                aspectRatio="1.58"
                width="2.375em"
              />
              <CertificationLogo
                src="/images/mc.svg"
                alt="Certification logo"
                aspectRatio="1.54"
                width="2.3125em"
              />
            </CopyrightSection>
          </CompanyInfo>
        </MainContent>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
